import { render, staticRenderFns } from "./VIPclasssixth.vue?vue&type=template&id=1e1d25a7&scoped=true"
import script from "./VIPclasssixth.vue?vue&type=script&lang=js"
export * from "./VIPclasssixth.vue?vue&type=script&lang=js"
import style0 from "./VIPclasssixth.vue?vue&type=style&index=0&id=1e1d25a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1d25a7",
  null
  
)

export default component.exports